import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { WholesalerEntity } from './wholesaler.entity';

/**
 * PD-17066 — another name a competitor goes by ("MCK" for McKesson), kept in
 * its own table so each name is searchable and belongs to one competitor
 * only. A merge turns the merged competitor's name into an alias of the one it
 * was merged into. SM2-only; SM1 never reads it.
 *
 * The name is unique across the table, soft-deleted rows included, so the
 * service recovers a deleted alias instead of inserting the same name again.
 */
@Index('wholesaler_alias_name_uindex', ['name'], { unique: true })
@Index('wholesaler_alias_fk_wholesaler__id', ['fkWholesalerId'], {})
@Entity('wholesaler_alias')
export class WholesalerAliasEntity extends BaseEntity {
	@Column('int', { name: 'fk_wholesaler__id', unsigned: true })
	public fkWholesalerId!: number;

	@Column('varchar', { name: 'name', length: 255 })
	public name!: string;

	@ManyToOne(() => WholesalerEntity, (wholesaler) => wholesaler.aliases, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_wholesaler__id', referencedColumnName: 'id' }])
	public wholesaler!: WholesalerEntity;
}
